import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import type { BidOverviewSummaryPageQueryParams } from '@/features/bidding/endpoints/bidOverviewSummary'
import { getBidOverviewSummary } from '@/features/bidding/endpoints/bidOverviewSummary'
import { useErrorHandler } from '@/features/bidding/hooks/useErrorHandler'
import type { BidOverviewSummaryPage } from '@/features/bidding/types/bidOverviewSummary'
import type { UseQueryOptions } from '@/types/queries'

const GET_BID_OVERVIEW_SUMMARY_API_ID = 'GET_BID_OVERVIEW_SUMMARY'

export type UseBidOverviewSummaryPageQueryResult = Omit<UseQueryResult, 'data'> & {
  bidOverviewSummaryPage: BidOverviewSummaryPage | null
}

export const useBidOverviewSummaryPageQuery = (
  params: BidOverviewSummaryPageQueryParams,
  options?: UseQueryOptions<BidOverviewSummaryPage>,
): UseBidOverviewSummaryPageQueryResult => {
  const { data, ...queryResult } = useQuery({
    ...options,
    queryKey: [GET_BID_OVERVIEW_SUMMARY_API_ID, params],
    queryFn: () => getBidOverviewSummary(params),
  })

  useErrorHandler(queryResult.isError)
  return { bidOverviewSummaryPage: data ?? null, ...queryResult }
}

export const useInvalidateBidOverviewSummaryPageQuery = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [GET_BID_OVERVIEW_SUMMARY_API_ID] })
}
